import * as React from 'react'
import Button from '@mui/material/Button'

import Link from '~/client/components/Link'
import ButtonRow from '~/client/components/ButtonRow'

export default function FormButtonRow({
  children,
  onSubmit,
  onCancel,
  onReset,
  cancelTo,
  disabled = false,
  submittable = true,
  submitting = false,
  submitText = 'submit',
  submittingText = 'submitting…',
  autoFocusSubmitButton = false,
  ...props
}){
  return <ButtonRow{...props}>
    <Button {...{
      autoFocus: autoFocusSubmitButton,
      disabled: disabled || !submittable || submitting,
      type: 'submit',
      variant: 'contained',
      onClick: onSubmit,
    }}>
      {submitting ? submittingText : submitText}
    </Button>

    {onReset
      ? <Button {...{
        disabled: disabled || !submittable || submitting,
        variant: 'text',
        onClick: onReset,
      }}>reset</Button>
      : null
    }

    {(onCancel || cancelTo)
      ? <Button {...{
        disabled: disabled || submitting,
        variant: 'text',
        onClick: onCancel,
        component: cancelTo && Link,
        to: cancelTo,
      }}>cancel</Button>
      : null
    }
  </ButtonRow>
}
